/**
 * Lightweight intl/currency logging — useful in production, explicit in development.
 */

const seenKeys = new Set();

function shouldLog(level) {
  if (process.env.NODE_ENV === "development") {
    return true;
  }
  return level === "warn" || level === "error";
}

function logOnce(key, level, message, detail) {
  if (seenKeys.has(key)) {
    return;
  }
  seenKeys.add(key);
  if (!shouldLog(level)) {
    return;
  }
  const logger = level === "error" ? console.error : console.warn;
  if (detail != null) {
    logger(`[intl] ${message}`, detail);
  } else {
    logger(`[intl] ${message}`);
  }
}

export function logMissingCatalogKey(locale, key) {
  logOnce(`missing-key:${locale}:${key}`, "warn", `Missing catalog key: ${key} (${locale})`);
}

export function logUnsupportedLocale(locale, context = "") {
  logOnce(`unsupported-locale:${locale}:${context}`, "warn", `Unsupported locale "${locale}"${context ? ` (${context})` : ""}`);
}

export function logUnsupportedCurrency(currency, context = "") {
  logOnce(`unsupported-currency:${currency}:${context}`, "warn", `Unsupported currency "${currency}"${context ? ` (${context})` : ""}`);
}

export function logFxFetchFailed(error) {
  logOnce("fx-fetch-failed", "warn", "FX rates fetch failed; using fallback.", error?.message || error);
}

export function logFxStaleFallback(source) {
  logOnce(`fx-stale:${source || "unknown"}`, "warn", `Serving stale FX fallback (${source || "unknown"}).`);
}

export function logInvalidManifestI18n(message, detail) {
  logOnce(`manifest-i18n:${message}`, "warn", `Invalid Client View i18n: ${message}`, detail);
}

export function logTranslationExportError(message, detail) {
  logOnce(`translation-export:${message}`, "warn", `Translation export error: ${message}`, detail);
}

export function logLocalizedRouteFailure(message, detail) {
  logOnce(`route-locale:${message}`, "warn", `Localized route resolution failed: ${message}`, detail);
}

export function resetIntlLoggerForTests() {
  seenKeys.clear();
}
